import { render, staticRenderFns } from "./InventoryDetailTables.vue?vue&type=template&id=072b074f&"
import script from "./InventoryDetailTables.vue?vue&type=script&lang=js&"
export * from "./InventoryDetailTables.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDetailTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports